<main class="auth-page min-vh-100 bg-light">
  <div class="container min-vh-100 d-flex align-items-center py-5">
    <div class="auth-panel row g-0 w-100 justify-content-center shadow-lg rounded-4 overflow-hidden bg-white">
      <section class="auth-brand-panel col-lg-6 text-white p-4 p-md-5 d-none d-lg-flex flex-column">
        <router-link to="/login" class="d-inline-flex bg-white rounded-3 p-3 shadow" aria-label="Department of Basic Education login">
          <span class="auth-logo d-block" aria-hidden="true"></span>
        </router-link>

        <div class="my-auto py-5">
          <p class="text-uppercase small text-white-50 fw-semibold mb-2">Account recovery</p>
          <h1 class="display-6 fw-bold mb-3">Let's get you back into the DBE dashboard.</h1>
          <p class="text-white-50 mb-0">
            Request a secure reset link and return to education progress insights.
          </p>
        </div>
      </section>

      <section class="col-lg-6 p-4 p-md-5 d-flex align-items-center">
        <div class="mx-auto w-100 py-lg-4" style="max-width: 28rem;">
          <router-link to="/login" class="d-flex d-lg-none justify-content-center mb-4" aria-label="Department of Basic Education login">
            <span class="auth-logo auth-logo-navbar d-block" aria-hidden="true"></span>
          </router-link>

          <h2 class="h3 fw-bold mb-2">Forgot your password?</h2>
          <p class="text-secondary mb-4">
            Enter your email and we'll send you a link to reset your password.
          </p>

          <SnackbarMessage
            :error-message="error_message"
            :success-message="success_message"
            @dismiss-error="error_message = ''"
            @dismiss-success="success_message = ''"
          />

          <div v-if="is_loading" class="d-flex align-items-center justify-content-center gap-2 text-secondary py-4">
            <span class="spinner-border spinner-border-sm text-primary" aria-hidden="true"></span>
            <span>Sending reset link...</span>
          </div>

          <form v-if="!is_loading" @submit.prevent="handleReset">
            <div class="mb-4">
              <label class="form-label fw-semibold small" for="reset-email">Email address</label>
              <div class="input-group">
                <span class="input-group-text bg-white text-secondary">
                  <i class="bi bi-envelope" aria-hidden="true"></i>
                </span>
                <input
                  id="reset-email"
                  v-model="email"
                  type="email"
                  class="form-control"
                  placeholder="name@education.gov.za"
                  autocomplete="email"
                  required
                  :disabled="is_loading"
                />
              </div>
            </div>

            <button class="btn btn-primary w-100 py-2 mb-3 d-inline-flex align-items-center justify-content-center gap-2" :disabled="is_loading">
              Send reset link
              <i class="bi bi-arrow-right" aria-hidden="true"></i>
            </button>

            <p class="text-center text-secondary small mb-0">
              Remember your password?
              <router-link to="/login" class="text-decoration-none fw-semibold text-primary">
                Sign in
              </router-link>
            </p>
          </form>
        </div>
      </section>
    </div>
  </div>
</main>
